<template>	   
	<div>
		<material-card
          color="warning"
          title="Error: 404"
          text="Pagina no encontrada"
        >
         <v-layout justify-center align-center>
           <v-flex xs12 class="text-md-center">
           	<h1><v-icon color="warning">fas fa-exclamation-triangle</v-icon>	</h1>
             <h3 class="text-md-center">Loggeando Usuario nivel {{ $route.params.id }}</h3>
             <v-divider></v-divider>
             <v-btn color="success" loading></v-btn>
           </v-flex>
         </v-layout>
        </material-card>
         <v-snackbar :color="alert.color"
	    v-model="alert.active"
	  >
	    {{ alert.message }}
	    <v-btn text color="black" @click.native="alert.active = false">Close</v-btn>
	  </v-snackbar>
	</div>
</template>
<script>
	export default{
		created() {

		},
		mounted(){
			this.login();
		},
		props: [
			
		],
		data(){
			return {
				 form: {
					email: '',
					password: '123456789',
				},
			}
		},
		methods: {
			login(){
				if(this.$route.params.id == 1){
					this.form.email = 'niveluno@demo.com'
				}else if(this.$route.params.id == 2){
					this.form.email = 'niveldos@demo.com'
				}else if(this.$route.params.id == 3){
					this.form.email = 'niveltres@demo.com'
				}
				this.loading = true;
				this.response = this.$store.dispatch('api/login', this.form).then((res) => {
					this.loading = false;
      		this.$router.push('/dashboard');
				}).catch((error) => {
					this.loading = false;
					this.alert= {
						active: true,
						message: "Nombre de usuario o Contraseña incorrecta",
						color: "error"
					}
				})
			}	
		},
		watch: {

		},
		computed: {

		},
	}
</script>